import axios from "axios";

const headers = {
  Accept: "application/json",
};

if (process.env.REACT_APP_TENANT) {
  headers["X-Tenant"] = process.env.REACT_APP_TENANT;
}

const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/api`;

const api = axios.create({
  baseURL: apiBaseUrl,
  headers,
});

export async function fetchJson(path, options = {}) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers: {
      ...headers,
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
}

export default api;
